import React, {Component} from 'react';
import {Link} from 'react-router-dom'
import WebsiteBot from './components/website-bot/WebsiteBot';
import imagesPath from './config/imagesPath';


class Footer extends Component {
    render() {
        return (
            <footer id="footer">
                <div className="gray-bgcolor"></div>
                <div className="blue-bgcolor"></div>
                <div className="footer-top">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-3 col-md-6 footer-contact">
                                <img src={require('./images/logo.png')} className="footer-logo" alt="logo"/>
                                <div className="social-links d-md-flex align-items-center mt30">
                                    <a href="https://www.linkedin.com/company/revfinserv/" target="_blank"><i
                                        className="bi bi-linkedin"></i></a>
                                    <a href="https://www.youtube.com/channel/UCQapP0XsbMsCRe5LM_MRYzw?view_as=subscriber"
                                       target="_blank"><i className="bi bi-youtube"></i></a>
                                    <a href="https://www.facebook.com/revfinindia/" target="_blank"><i
                                        className="bi bi-facebook"></i></a>
                                    <a href="https://www.instagram.com/revfinindia/" target="_blank"><i
                                        className="bi bi-instagram"></i></a>
                                    <a href="https://twitter.com/revfinindia" target="_blank">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                             fill="currentColor" class="bi bi-twitter-x" viewBox="0 0 16 16">
                                            <path
                                                d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"/>
                                        </svg>
                                    </a>
                                </div>
                                <br/>
                                <div>
                                    <img src="https://revfinuser-docs.s3.ap-south-1.amazonaws.com/iso-cert.png" alt=""
                                         width="80px" height="80px" style={{
                                        objectFit: 'contain'
                                    }}></img>
                                    <img src={imagesPath.img28} alt="" width="100px" height="100px" style={{
                                        objectFit: 'contain'
                                    }}></img>
                                </div>

                            </div>
                            <div className="col-lg-3 col-md-6 footer-links">
                                <h4>Contact Us</h4>
                                <h6>REVFIN SERVICES PRIVATE LIMITED</h6>
                                <p>2nd Floor, E-Block
                                    International Trade Tower
                                    Nehru Place
                                    New Delhi
                                    South Delhi
                                    DL 110019 IN</p>
                                <p><a href="mailto:care@revfin.in">care@revfin.in</a>
                                    <br/><br/> <a href="tel:+918686738738">+918686738738</a></p>
                            </div>
                            <div className="col-lg-2 col-md-6 footer-links">
                                <h4>Quick Links</h4>
                                <ul>
                                    <li><Link to="/about-us">About Us</Link></li>
                                    <li><Link to="/product">Our Products</Link></li>
                                    <li><Link to="/partner">Our Partners</Link></li>
                                    {/* <li> <Link to="/moratorium">Moratorium</Link></li> */}
                                    <li><Link to="/media">Media</Link></li>
                                    <li><Link to="/contact">Contact Us</Link></li>
                                    <li><Link to="/career">Career</Link></li>
                                    <li><a
                                        href="https://revfin-dev.s3.ap-south-1.amazonaws.com/Zimmedari_Ki_Sawaari_T%26C.pdf"
                                        target="_blank" rel="noopener noreferrer">Zimmedari ki Sawaari</a></li>
                                </ul>
                            </div>
                            <div className="col-lg-2 col-md-6 footer-links">
                                <h4>Useful Links</h4>
                                <ul>
                                    <li><Link to="/privacy_and_policy">Privacy Policy</Link></li>
                                    <li><a
                                        href="https://revfin-dev.s3.ap-south-1.amazonaws.com/Equal+Opportunity+Policy_Revfin.pdf"
                                        target="_blank" rel="noopener noreferrer">Equal Opportunity Policy</a></li>
                                    <li><Link to="/ispolicystatement">Information Security Policy</Link></li>
                                    <li><Link to="/terms_and_conditions">Terms & Conditions</Link></li>
                                    <li><a href="https://sachet.rbi.org.in/" target="_blank" rel="noopener noreferrer">RBI
                                        Sachet</a></li>
                                    <li><Link to="/cancelmandate">NACH mandate Cancellation</Link></li>
                                    <li><Link to="/disclaimer-revised">Disclaimer</Link></li>
                                    <li><Link to="/faq">FAQ</Link></li>
                                    <li><a href="https://revfinuser-docs.s3.amazonaws.com/dlai_20231120.pdf"
                                           target="_blank" rel="noopener noreferrer">Code of Conduct for Responsible
                                        Digital Lending</a></li>
                                    <li><Link to="/annual-returns">Annual Returns</Link></li>
                                </ul>
                            </div>
                            <div className="col-lg-2 col-md-6 footer-links">
                                <h4>Downloads</h4>
                                <a href="https://apps.apple.com/in/app/revfin/id1454364758" target="_blank">
                                    <img src={imagesPath.img25} className="mb-4 mt-4 download-app-icon" alt=''/>
                                </a>
                                <a href="https://play.google.com/store/apps/details?id=com.revfin_ptech18"
                                   target="_blank">
                                    <img src={imagesPath.img27} alt=''/>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <WebsiteBot/>
            </footer>

        )
    }

}

export default Footer



// WEBPACK FOOTER //
// ./src/footer.js